var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("form", { attrs: { "data-vv-scope": "step-3-part-1" } }, [
      _vm._m(0),
      _c("div", { staticClass: "row mb-3" }, [
        _c(
          "div",
          { staticClass: "col-md-9" },
          [
            _c("vs-input", {
              directives: [
                {
                  name: "validate",
                  rawName: "v-validate",
                  value: "required",
                  expression: "'required'"
                }
              ],
              staticClass: "w-100",
              attrs: {
                label:
                  "Documento Principal (Si piensa firmar\n          electrónicamente no debe ser escaneado) (*)",
                name: "mainFileName",
                readonly: "",
                danger: _vm.errors.has("step-3-part-1.mainFileName"),
                "danger-text": _vm.errors.first("step-3-part-1.mainFileName")
              },
              model: {
                value: _vm.step.mainFile.name,
                callback: function($$v) {
                  _vm.$set(_vm.step.mainFile, "name", $$v)
                },
                expression: "step.mainFile.name"
              }
            })
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col-md-3 d-flex align-items-end" },
          [
            _c("UploadFile", {
              attrs: {
                permission: "*",
                accept: "application/pdf",
                text: "Seleccionar",
                "data-cy": "select-File",
                "upload-to": "ed",
                "button-class": {
                  "btn-block": true,
                  "mb-5": _vm.errors.has("step-3-part-1.mainFileName")
                },
                "container-class": "w-100"
              },
              model: {
                value: _vm.step.mainFile,
                callback: function($$v) {
                  _vm.$set(_vm.step, "mainFile", $$v)
                },
                expression: "step.mainFile"
              }
            })
          ],
          1
        ),
        _c("div", { staticClass: "col-md-12" }, [
          _vm.error.message !== ""
            ? _c(
                "div",
                {
                  staticClass:
                    "con-text-validation span-text-validation-danger\n         vs-input--text-validation-span v-enter-to",
                  staticStyle: { height: "32px" }
                },
                [
                  _c("span", { staticClass: "span-text-validation" }, [
                    _vm._v(" " + _vm._s(_vm.error.message) + " ")
                  ])
                ]
              )
            : _vm._e()
        ])
      ]),
      _c("div", { staticClass: "row mb-3" }, [
        _c(
          "div",
          { staticClass: "col-md-9" },
          [
            _c("vs-input", {
              staticClass: "w-100",
              attrs: {
                label: "Archivo Adjunto",
                name: "additionalFileName",
                readonly: ""
              },
              model: {
                value: _vm.additionalFile.name,
                callback: function($$v) {
                  _vm.$set(_vm.additionalFile, "name", $$v)
                },
                expression: "additionalFile.name"
              }
            })
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col-md-3 d-flex align-items-end" },
          [
            _c("UploadFile", {
              attrs: {
                permission: "*",
                text: "Seleccionar",
                "data-cy": "Select-additional-file-gitbutton",
                accept: "application/pdf",
                "upload-to": "ed",
                "button-class": "btn-block",
                "container-class": "w-100"
              },
              on: {
                input: function($event) {
                  return _vm.addAdditionalFile()
                }
              },
              model: {
                value: _vm.additionalFile,
                callback: function($$v) {
                  _vm.additionalFile = $$v
                },
                expression: "additionalFile"
              }
            })
          ],
          1
        )
      ]),
      Object.keys(_vm.step.mainFile).length
        ? _c(
            "div",
            { staticClass: "row mb-3" },
            [
              _c("div", { staticClass: "col-3" }, [
                _c(
                  "div",
                  { staticClass: "d-flex flex-column align-items-center" },
                  [
                    _c("vs-icon", {
                      attrs: {
                        icon: "description",
                        size: "75px",
                        color: "primary"
                      }
                    }),
                    _c(
                      "b",
                      { staticClass: "text-truncate w-100 text-center" },
                      [_vm._v(_vm._s(_vm.step.mainFile.name))]
                    )
                  ],
                  1
                )
              ]),
              _vm._l(_vm.step.additionalFiles, function(file) {
                return _c("div", { key: file.id, staticClass: "col-3" }, [
                  _c(
                    "div",
                    { staticClass: "d-flex flex-column align-items-center" },
                    [
                      _c("vs-icon", {
                        attrs: {
                          icon: "description",
                          size: "75px",
                          color: "primary"
                        }
                      }),
                      _c(
                        "b",
                        { staticClass: "text-truncate w-100 text-center" },
                        [_vm._v(_vm._s(file.name))]
                      ),
                      _c("vs-button", {
                        attrs: { color: "danger", type: "flat", icon: "clear" },
                        on: {
                          click: function($event) {
                            return _vm.removeAdditionalFile(file.id)
                          }
                        }
                      })
                    ],
                    1
                  )
                ])
              })
            ],
            2
          )
        : _vm._e(),
      _c("div", { staticClass: "row mb-3" }, [
        _c("div", { staticClass: "col-12" }, [_c("vs-divider")], 1)
      ])
    ]),
    _c("form", { attrs: { "data-vv-scope": "step-3-part-2" } }, [
      _vm._m(1),
      _vm.isMop
        ? _c("div", { staticClass: "row mb-3" }, [
            _c(
              "div",
              { staticClass: "col-md-6" },
              [
                _c("vs-input", {
                  staticClass: "w-100",
                  attrs: {
                    label: "Contrato SAFI",
                    maxlength: "10",
                    name: "safiContract"
                  },
                  model: {
                    value: _vm.step.safiContract,
                    callback: function($$v) {
                      _vm.$set(_vm.step, "safiContract", $$v)
                    },
                    expression: "step.safiContract"
                  }
                })
              ],
              1
            ),
            _vm._m(2)
          ])
        : _vm._e(),
      _vm.isMop
        ? _c("div", { staticClass: "row mb-3" }, [
            _c("div", { staticClass: "col-12" }, [_c("vs-divider")], 1)
          ])
        : _vm._e(),
      _c("div", { staticClass: "row mb-3" }, [
        _c(
          "div",
          { staticClass: "col-md-6" },
          [
            _c("list-all-document-types", {
              directives: [
                {
                  name: "validate",
                  rawName: "v-validate",
                  value: "required",
                  expression: "'required'"
                }
              ],
              ref: "documentTypes",
              staticClass: "w-100",
              attrs: {
                usage: "referencias",
                autocomplete: "",
                label: "Tipo Documento",
                name: "documentType",
                danger: _vm.errors.has("step-3-part-2.documentType"),
                "danger-text": _vm.errors.first("step-3-part-2.documentType")
              },
              model: {
                value: _vm.relatedDocument.type,
                callback: function($$v) {
                  _vm.$set(_vm.relatedDocument, "type", $$v)
                },
                expression: "relatedDocument.type"
              }
            })
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col-md-6" },
          [
            _c("vs-input", {
              directives: [
                {
                  name: "validate",
                  rawName: "v-validate",
                  value: "required",
                  expression: "'required'"
                }
              ],
              staticClass: "w-100",
              attrs: {
                label: "Nº Documento",
                name: "relatedDocumentNumber",
                danger: _vm.errors.has("step-3-part-2.relatedDocumentNumber"),
                "danger-text": _vm.errors.first(
                  "step-3-part-2.relatedDocumentNumber"
                )
              },
              model: {
                value: _vm.relatedDocument.number,
                callback: function($$v) {
                  _vm.$set(_vm.relatedDocument, "number", $$v)
                },
                expression: "relatedDocument.number"
              }
            })
          ],
          1
        )
      ]),
      _c("div", { staticClass: "row mb-3" }, [
        _c(
          "div",
          { staticClass: "col-12 d-flex align-items-end justify-content-end" },
          [
            _c(
              "vs-button",
              {
                attrs: {
                  "data-cy": "add-relationship-button",
                  color: "primary",
                  icon: "add"
                },
                on: {
                  click: function($event) {
                    return _vm.addRelatedDocument()
                  }
                }
              },
              [_vm._v(" Agregar relación ")]
            )
          ],
          1
        )
      ]),
      _c("div", { staticClass: "row mb-3" }, [
        _c(
          "div",
          { staticClass: "col-12" },
          [
            _c(
              "vs-table",
              {
                staticClass: "pb-2 mb-2",
                attrs: {
                  multiple: "",
                  "no-data-text": "No tienes documentos relacionados",
                  data: _vm.step.relatedDocuments
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(ref) {
                      var data = ref.data
                      return _vm._l(data, function(tr, indextr) {
                        return _c(
                          "vs-tr",
                          { key: indextr, attrs: { data: tr } },
                          [
                            _c(
                              "vs-td",
                              { attrs: { data: data[indextr].type } },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.findLabelDocument(tr.type)) +
                                    " "
                                )
                              ]
                            ),
                            _c(
                              "vs-td",
                              { attrs: { data: data[indextr].number } },
                              [_vm._v(" " + _vm._s(tr.number) + " ")]
                            )
                          ],
                          1
                        )
                      })
                    }
                  }
                ]),
                model: {
                  value: _vm.step.relatedDocumentsSelected,
                  callback: function($$v) {
                    _vm.$set(_vm.step, "relatedDocumentsSelected", $$v)
                  },
                  expression: "step.relatedDocumentsSelected"
                }
              },
              [
                _c(
                  "template",
                  { slot: "thead" },
                  [
                    _c("vs-th", [_vm._v("Relacionado con")]),
                    _c("vs-th", [_vm._v("Nº Documento")])
                  ],
                  1
                )
              ],
              2
            )
          ],
          1
        )
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row mb-3" }, [
      _c("div", { staticClass: "col-12" }, [
        _c("h4", [_vm._v("Adjuntar Documento")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row mb-3" }, [
      _c("div", { staticClass: "col-12" }, [
        _c("h4", [_vm._v("Documentos Relacionados")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-12" }, [
      _c(
        "div",
        {
          staticClass:
            "con-text-validation span-text-validation-danger\n         vs-input--text-validation-span v-enter-to",
          staticStyle: {
            height: "32px",
            "font-size": "12px",
            color: "#673ab7 !important"
          }
        },
        [
          _c("span", { staticClass: "span-text-validation" }, [
            _vm._v(
              " El número de Contrato SAFI en muchos casos es requerido, no lo olvides! "
            )
          ])
        ]
      )
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }